import { NgModule } from '@angular/core';
import { CardPaginationComponent } from '@components/card-pagination/card-pagination.component';
import { RaffleCardComponent } from '@components/raffle-card/raffle-card.component';
import { TextHolderComponent } from '@components/text-holder/text-holder.component';
import { NotFoundComponent } from '@project/components/not-found/not-found.component';
import { TemplateModule } from '@project/shared/template/template.module';
import { CategoryRafflesRoutingModule } from './category-raffles-routing.module';
import { CategoryRafflesComponent } from './category-raffles/category-raffles.component';

@NgModule({
  declarations: [CategoryRafflesComponent],
  imports: [
    CategoryRafflesRoutingModule,
    TemplateModule,
    RaffleCardComponent,
    TextHolderComponent,
    NotFoundComponent,
    CardPaginationComponent
  ]
})
export class CategoryRafflesModule {}
